export function buildKbAdminModesProps(input: any) {
  const { props, state: s, handlers: h, meta: m, constants: c, dictation } = input;
  return {
    starterUrl: c.STARTER_COMPANY_DOCS_URL,
    onNavigateToDevKbRescope: props.onNavigateToDevKbRescope,
    kbMode: s.kbMode,
    q: s.q,
    searchAudience: s.searchAudience,
    searchScope: s.searchScope,
    searchDocType: s.searchDocType,
    searchStatus: s.searchStatus,
    results: s.results,
    selected: s.selected,
    draftCount: s.draftCount,
    draftsLoading: s.draftsLoading,
    canPublishKb: m.canPublishKb,
    publishWorking: s.publishWorking,
    deleteWorking: s.deleteWorking,
    confirmPublishSlug: s.confirmPublishSlug,
    confirmDeleteSlug: s.confirmDeleteSlug,
    setQ: s.setQ,
    setSearchAudience: s.setSearchAudience,
    setSearchScope: s.setSearchScope,
    setSearchDocType: s.setSearchDocType,
    setSearchStatus: s.setSearchStatus,
    doChunkAudit: h.doChunkAudit,
    doSearch: h.doSearch,
    resetSearchFilters: h.resetSearchFilters,
    loadDraftsIntoResults: h.loadDraftsIntoResults,
    loadArticle: h.loadArticle,
    setConfirmPublishSlug: s.setConfirmPublishSlug,
    setConfirmDeleteSlug: s.setConfirmDeleteSlug,
    doPublishDraft: h.doPublishDraft,
    doSoftDelete: h.doSoftDelete,
    setKbMode: s.setKbMode,
    canUseQuickChunkAudit: m.canUseQuickChunkAudit,
    quickAuditEnabled: s.quickAuditEnabled,
    setQuickAuditEnabled: s.setQuickAuditEnabled,
    quickAuditRisk: s.quickAuditRisk,
    setQuickAuditRisk: s.setQuickAuditRisk,
    showDevRescopePill: m.showDevRescopePill,
    devRescopeBusy: s.devRescopeBusy,
    devRescopeFromLibraryResult: h.devRescopeFromLibraryResult,
    aiArticleLinkSuggestions: s.aiArticleLinkSuggestions,
    aiAudienceHint: s.aiAudienceHint,
    setAiAudienceHint: s.setAiAudienceHint,
    aiBodyDraft: s.aiBodyDraft,
    setAiBodyDraft: s.setAiBodyDraft,
    aiBodyGenerationNotes: s.aiBodyGenerationNotes,
    aiBusy: s.aiBusy,
    aiDocTypeHint: s.aiDocTypeHint,
    setAiDocTypeHint: s.setAiDocTypeHint,
    aiFeedback: s.aiFeedback,
    aiFollowOnDocs: s.aiFollowOnDocs,
    aiGapsOpen: s.aiGapsOpen,
    setAiGapsOpen: s.setAiGapsOpen,
    aiGeneratedNotes: s.aiGeneratedNotes,
    aiGuidance: m.aiGuidance,
    aiHelpOpen: s.aiHelpOpen,
    setAiHelpOpen: s.setAiHelpOpen,
    aiKbGapCandidates: s.aiKbGapCandidates,
    aiLinksOpen: s.aiLinksOpen,
    setAiLinksOpen: s.setAiLinksOpen,
    aiPlacementSummary: s.aiPlacementSummary,
    aiPurpose: s.aiPurpose,
    setAiPurpose: s.setAiPurpose,
    aiQuestionAnswers: s.aiQuestionAnswers,
    aiRecommendedDocCount: s.aiRecommendedDocCount,
    aiRelatedArticles: s.aiRelatedArticles,
    aiResolvedFacts: s.aiResolvedFacts,
    aiScopeHint: s.aiScopeHint,
    setAiScopeHint: s.setAiScopeHint,
    aiSourceKind: s.aiSourceKind,
    setAiSourceKind: s.setAiSourceKind,
    aiStopReason: s.aiStopReason,
    aiSuggestedAction: s.aiSuggestedAction,
    aiTopicComplexity: s.aiTopicComplexity,
    aiUpdateMetadata: s.aiUpdateMetadata,
    setAiUpdateMetadata: s.setAiUpdateMetadata,
    aiUpdateTitle: s.aiUpdateTitle,
    setAiUpdateTitle: s.setAiUpdateTitle,
    appliedSuggestion: s.appliedSuggestion,
    applyAiBodyDraft: h.applyAiBodyDraft,
    applyDictationToPurpose: h.applyDictationToPurpose,
    articleAudience: s.articleAudience,
    setArticleAudience: s.setArticleAudience,
    articleContent: s.articleContent,
    setArticleContent: s.setArticleContent,
    articleDocType: s.articleDocType,
    setArticleDocType: s.setArticleDocType,
    articleMode: s.articleMode,
    setArticleMode: s.setArticleMode,
    articleScope: s.articleScope,
    setArticleScope: s.setArticleScope,
    articleSlug: s.articleSlug,
    articleSourceUrl: s.articleSourceUrl,
    setArticleSourceUrl: s.setArticleSourceUrl,
    articleStatus: s.articleStatus,
    setArticleStatus: s.setArticleStatus,
    articleTagsInput: s.articleTagsInput,
    setArticleTagsInput: s.setArticleTagsInput,
    articleTitle: s.articleTitle,
    setArticleTitle: s.setArticleTitle,
    broaderScopeLocked: m.broaderScopeLocked,
    canManageManufacturerScope: m.canManageManufacturerScope,
    canManageAppScope: m.canManageAppScope,
    defaultArticleTitle: m.defaultArticleTitle,
    dictationProps: { isSupported: dictation.isSupported, isListening: dictation.isListening, draft: dictation.draft, error: dictation.error, start: dictation.start, stop: dictation.stop },
    doArticle: h.doArticle,
    doCreateSplitStubs: h.doCreateSplitStubs,
    doProposeSplit: h.doProposeSplit,
    gapSaving: s.gapSaving,
    hasEditorName: m.hasEditorName,
    lastArticleId: s.lastArticleId,
    loadedArticle: s.loadedArticle,
    preserveOriginalBody: s.preserveOriginalBody,
    setPreserveOriginalBody: s.setPreserveOriginalBody,
    previousArticleContent: s.previousArticleContent,
    previewRelatedArticle: h.previewRelatedArticle,
    publishedArticleLocked: m.publishedArticleLocked,
    devRescopeFromEditor: h.devRescopeFromEditor,
    relatedPreview: s.relatedPreview,
    setRelatedPreview: s.setRelatedPreview,
    relatedPreviewLoading: s.relatedPreviewLoading,
    clearWorkspace: h.clearWorkspace,
    resetAiSession: h.resetAiSession,
    restorePreviousBody: h.restorePreviousBody,
    runAiHelp: h.runAiHelp,
    saveGapsToInbox: h.saveGapsToInbox,
    setAiQuestionDisposition: h.setAiQuestionDisposition,
    setSplitOpen: s.setSplitOpen,
    setSplitProposals: s.setSplitProposals,
    showAiFeedback: h.showAiFeedback,
    splitCreating: s.splitCreating,
    splitOpen: s.splitOpen,
    splitProposals: s.splitProposals,
    splitWorking: s.splitWorking,
    updateAiQuestionAnswer: h.updateAiQuestionAnswer,
    chunkQuality: s.chunkQuality,
    chunkQualityAdvice: s.chunkQualityAdvice,
    editorName: m.editorName,
    showNote: h.showNote,
    setPendingProposalCount: s.setPendingProposalCount,
    gapInboxOpenCount: s.gapInboxOpenCount,
    gapInboxStatusFilter: s.gapInboxStatusFilter,
    gapInboxLoading: s.gapInboxLoading,
    gapInboxItems: s.gapInboxItems,
    gapInboxPage: s.gapInboxPage,
    gapInboxPageSize: s.gapInboxPageSize,
    gapInboxListTotal: s.gapInboxListTotal,
    gapInboxTestingOnly: s.gapInboxTestingOnly,
    setGapInboxTestingOnly: s.setGapInboxTestingOnly,
    setGapInboxPage: s.setGapInboxPage,
    refreshGapInbox: h.refreshGapInbox,
    setGapInboxStatusFilter: s.setGapInboxStatusFilter,
    setGapInboxPageSize: s.setGapInboxPageSize,
    updateGapStatus: h.updateGapStatus,
    addressGapItem: h.addressGapItem,
    suggestGapSolution: h.suggestGapSolution,
    resolveGapByLink: h.resolveGapByLink,
    isBulkImporting: s.isBulkImporting,
    bulkImportText: s.bulkImportText,
    bulkAllowPolicyOverwrite: s.bulkAllowPolicyOverwrite,
    setBulkAllowPolicyOverwrite: s.setBulkAllowPolicyOverwrite,
    loadStarterCompanyDocs: h.loadStarterCompanyDocs,
    setBulkImportText: s.setBulkImportText,
    doBulkImport: h.doBulkImport,
    trashLoading: s.trashLoading,
    trashResults: s.trashResults,
    confirmPurgeSlug: s.confirmPurgeSlug,
    loadTrash: h.loadTrash,
    setConfirmPurgeSlug: s.setConfirmPurgeSlug,
    doPurge: h.doPurge,
    note: s.note,
    notesOpen: s.notesOpen,
    setNotesOpen: s.setNotesOpen,
  };
}
